import { render, staticRenderFns } from "./IconSimulation.vue?vue&type=template&id=adb8b278"
import script from "./IconSimulation.vue?vue&type=script&lang=js"
export * from "./IconSimulation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports